import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { ShipmentBundle } from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import { setDeliveryDetailsAction } from '../slice';
import getCommonProductRequestParams from '../selector/getCommonProductRequestParams';

const fetchDeliveryDetailsOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { categoryId, locale, productId } = getCommonProductRequestParams(store);

    const deliveryData = (await apiRequest(
      endpoints.shipmentPriceV2List,
      {
        productIds: [productId],
        categoryId,
        locale,
      },
      HttpMethods.POST,
      'data',
    )) as ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListV2Response;

    dispatch(setDeliveryDetailsAction(deliveryData));
  };

export default fetchDeliveryDetailsOperation;
